<template lang="pug">
  #app
    app-header.above
    main.main
      router-view.above
      .load-font Atlanta Falcons
      .load-font.archivo Atlanta Falcons
      .load-font.archivo-blk Atlanta Falcons
      .load-font.archivo-nw Atlanta Falcons
    app-footer.above
</template>

<script>
import debug from 'debug'

import AppHeader from './components/AppHeader'
import AppFooter from './components/AppFooter'

const log = debug('app')

export default {
  name: 'app',
  data () {
    return {}
  },
  mounted () {
    log('App Mounted')
  },
  computed: {},
  methods: {},
  components: { AppHeader, AppFooter },
}
</script>

<style lang="scss">
@import './styles/main';

html {
  background-color: black;
}

body {
  background: url('./assets/chalk_bg.jpg') center/cover fixed;
  overflow: scroll;
  overflow-x: hidden;
}

#app {
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-flow: column nowrap;
}

.background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  background-image: url('./assets/chalk_bg.jpg');
  background-size: cover;
  z-index: 0;
}

.main {
  // padding-bottom: 4rem;
  flex: 1;

  @media (min-height: 940px) and (min-width: 640px) {
    padding-bottom: 8rem;
  }
}

.above {
  position: relative;
  z-index: 1;
}

.load-font {
  visibility: hidden;
  font-family: 'pure_heartregular';

  &.archivo {
    font-family: "Archivo";
  }
  &.archivo-blk {
    font-family: "Archivo Black";
  }
  &.archivo-nw {
    font-family: "Archivo Narrow";
  }
}
</style>
